<template>
	<v-card class="announcement">
		<div class="announcement-title">
			{{ announcement.title ?? '公告' }}
			<div v-if="showClose" class="announcement-close" @click="$emit('close')">
				<v-icon>mdi-close</v-icon>
			</div>
		</div>
		<div class="announcement-line" />
		<div class="announcement-body">
			<div class="announcement-body-content">
				<div v-html="$sanitizeHtml(announcement.content)"></div>
			</div>
		</div>
		<div class="announcement-date">
			{{ $formatDate(new Date(announcement.startTime), 'yyyy-MM-dd HH:mm') }}
			~
			<template v-if="announcement.endTime">
				{{ $formatDate(new Date(announcement.endTime), 'yyyy-MM-dd HH:mm') }}
			</template>
			<span v-else>永久</span>
		</div>
		<div class="announcement-action" v-if="announcement.type === 'TEXT'">
			<template v-if="!isRead">
				<v-btn
					color="lineColor"
					class="mr-2"
					outlined
					large
					:disabled="disabled"
					@click="$emit('markRead')"
				>
					知道了
				</v-btn>
				<v-btn
					color="com1Color"
					large
					:disabled="disabled"
					@click="$emit('remindLater')"
				>
					再提醒
				</v-btn>
			</template>
			<v-btn
				v-else
				color="com1Color"
				large
				:disabled="disabled"
				@click="$emit('close')"
			>
				關閉
			</v-btn>
		</div>
		<div class="announcement-action" v-if="announcement.type === 'CLEAR_CACHE'">
			<v-btn
				v-if="!isRead"
				color="lineColor"
				class="mr-2"
				outlined
				large
				:disabled="disabled"
				@click="$emit('remindLater')"
			>
				再提醒
			</v-btn>
			<v-btn
				v-else
				color="lineColor"
				class="mr-2"
				outlined
				large
				:disabled="disabled"
				@click="$emit('close')"
			>
				關閉
			</v-btn>
			<v-btn
				color="com1Color"
				large
				:disabled="disabled"
				@click="$emit('clearCache')"
			>
				清除緩存
			</v-btn>
		</div>
		<div class="announcement-action" v-if="announcement.type === 'APP_UPDATE'">
			<v-btn
				v-if="isRead"
				color="lineColor"
				class="mr-2"
				outlined
				large
				:disabled="disabled"
				@click="$emit('close')"
			>
				關閉
			</v-btn>
			<v-btn
				v-if="isApp"
				color="com1Color"
				large
				:disabled="disabled"
				@click="$emit('appUpdate')"
			>
				前往更新
			</v-btn>
			<v-btn
				v-else-if="!isRead"
				color="com1Color"
				large
				:disabled="disabled"
				@click="$emit('markRead')"
			>
				知道了
			</v-btn>
		</div>
	</v-card>
</template>

<script>
export default {
	name: 'MyAnnouncementCard',
	props: {
		announcement: {
			required: true,
			type: Object,
		},
		showClose: {
			required: false,
			type: Boolean,
			default: false,
		},
		disabled: {
			required: false,
			type: Boolean,
			default: false,
		},
		// 已讀公告於「回顧」情境隱藏狀態決策按鈕（再提醒／知道了），僅保留功能動作與關閉
		isRead: {
			required: false,
			type: Boolean,
			default: false,
		},
	},
	computed: {
		// 是否為 APP（ReactNative WebView）環境；非 APP 裝置無法前往更新，改顯示「知道了」
		isApp() {
			return this.$isReactNative()
		},
	},
}
</script>

<style scoped lang="scss">
.announcement {
	padding: 16px;
	border-radius: 16px;
	background: $darkTextColor;
	display: flex;
	flex-direction: column;
	max-height: calc(var(--vh, 1vh) * 90);

	&-title {
		position: relative;
		padding-bottom: 16px;
		font-size: 1.5rem;
		font-weight: bold;
		color: $lightTextColor;
		display: flex;
		justify-content: center;
		align-items: center;

		.announcement-close {
			position: absolute;
			right: 0;
			top: 0;
			height: 32px;
			width: 32px;
			display: flex;
			justify-content: center;
			align-items: center;
			cursor: pointer;
			opacity: 0.7;
			transition: opacity 0.2s;

			&:hover {
				opacity: 1;
			}
		}
	}

	&-line {
		height: 2px;
		width: 100%;
		background: $lineColor;
	}

	&-body {
		flex: 1;
		overflow-y: auto;

		&-content {
			margin-bottom: 8px;

			&::v-deep {
				.v-textarea {
					.v-input__slot {
						box-shadow: none !important;
						padding: 0 !important;

						.v-text-field__slot {
							margin-right: 0;
						}

						.v-text-field__slot textarea {
							padding-right: 0 !important;
						}
					}
				}
			}
		}
	}

	&-date {
		padding-top: 8px;
		font-size: 1.125rem;
		color: $lightTextColor;
		opacity: 0.4;
		margin-bottom: 24px;
	}

	&-action {
		display: flex;
		align-items: center;

		&::v-deep {
			.v-btn {
				color: $lightTextColor !important;
				border-color: $lineColor !important;
				height: 56px !important;
				flex: 1;
			}
		}
	}

	@include rwd(766) {
		padding: 16px;
		&-title {
			padding-bottom: 13px;
		}

		&-date {
			margin-bottom: 12px;
		}
	}
}
</style>
